import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ERToolService } from '../../services/er-tool.service';
import { MatTableDataSource } from '@angular/material/table';

import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';

import { animate, state, style, transition, trigger } from '@angular/animations';
import { DrugCategory } from 'src/app/internal-user/drug-management/models/drug';

import { ImportWizardFileDownloadComponent } from '../import-wizard-file-download/import-wizard-file-download.component';
import { DropDown } from '../../../drug-management/models/dropdown';
import { DropdownValues } from '../../../drug-management/models/synmed-data';

@Component({
    selector: 'app-er-list',
    templateUrl: './er-list.component.html',
    styleUrls: ['./er-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ErListComponent implements OnInit {

  searchText:string = '';
  dataSource= new MatTableDataSource<DrugCategory>();
  columnsToDisplay = ['name', 'ndc', 'countryCode','source','system', 'strength', 'manufacturer'];
  expandedElement: DrugCategory | null;


  //#region Pagination properties
  totalRows: number = 0;
  currentPage: number = 0;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20, 40, 50];
  //#endregion
   dataSourceId:number= 0;
   countryId:number= 0;
   statusId:number=0;
   permanentQuarantineValue:boolean = false;
   searchResultsCount: number = 0;
   listOfCountry: DropDown[] = [];
   listOfDataSourceFilter: DropDown[] = [];
   permanentQuarantine: DropDown[] = DropdownValues.CommonBooleanDropDownValues;
   selectedSearchCriteria: any;   
  validationError: string = '';
  isValid: boolean = true;
  searchCriteria = [
    {
      value: 'drugNumber',
      label: 'Drug Number',
      pattern: /^[\d-]+$/,
      errorMsg: 'Drug number must contain only numbers'
    },
    {
      value: 'drugName',
      label: 'Drug Name',
      pattern: /^(?=.*[a-zA-Z0-9]).+$/,
      errorMsg: 'Drug name must contain at least one valid alphanumeric character.'
    },
    {
      value: 'pdbid',
      label: 'PDDBID',
      pattern: /^\d+$/,
      errorMsg: 'PDDBID must contain only numbers'
    },
    {
      value: 'tcgid',
      label: 'TCGID',
      pattern: /^\d+$/,
      errorMsg: 'TCGID must contain only numbers'
    },
    {
      value: 'genericNumber',
      label: 'Generic Number',
      pattern: /^\d+$/,
      errorMsg: 'Generic Number must contain only numbers'
    }
  ];

  // Drug Name radio options
  drugNameTypeOptions = [
    { value: 1, label: 'Drug Name' },
    { value: 2, label: 'Label Name' },
    { value: 3, label: 'Generic Name' },
    { value: 4, label: 'All' }
  ];
  selectedDrugNameType: number = 4;

 //#endregion
  constructor(
    private erToolService: ERToolService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private route: Router) { }

  ngOnInit(): void {
    this.selectedSearchCriteria = this.searchCriteria[0];

    this.getDrugData();
    this.getCountry();
    this.getDataSourceFilter();
    this.onSearchCriteriaChange();
  }

  handleSearchCountUpdate(count: number) {
    this.searchResultsCount = count;
  }

  onSearchCriteriaChange() {
    if (this.validateInput(this.searchText)) {
      this.getDrugData();
      this.updateSearchWizard();
    }
  }

  onCriteriaSelect(criteria: any) {
    this.selectedSearchCriteria = criteria;

    if (this.selectedSearchCriteria?.value !== 'drugName') {
      this.selectedDrugNameType = 4;
    }

    // If there's text, validate and fetch data if valid
    if (this.searchText && this.searchText.trim() !== '') {
      if (this.validateInput(this.searchText)) {
        this.getDrugData();
      }
    }
  }

  isDrugNameSelected(): boolean {
    return this.selectedSearchCriteria?.value === 'drugName';
  }

  onDrugNameTypeChange(value: number) {
    this.selectedDrugNameType = value;
    this.updateSearchWizard();
  }

  openImportWizardFileDownloadComponent(){

    const dialogRef = this.dialog.open(ImportWizardFileDownloadComponent, {
      width: '40%', 
    disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
      }
    });

  }

  validateInput(value: string): boolean {
    // Allow empty values to work normally
    if (!value || value.trim() === '') {
      this.validationError = '';
      this.isValid = true;
      return true;
    }

    const currentCriteria = this.searchCriteria.find(c => c.value === this.selectedSearchCriteria.value);
    if (!currentCriteria) {
      return false;
    }

    if (currentCriteria.value === 'drugName') {
      const startsWithSpecialCharacter = /^[^a-zA-Z0-9]/.test(value);
      const hasAlphanumericCharacter = /[a-zA-Z0-9]/.test(value);

      // Show validation only when Drug Name starts with special character(s)
      // and does not contain any valid alphanumeric character.
      if (startsWithSpecialCharacter && !hasAlphanumericCharacter) {
        this.validationError = currentCriteria.errorMsg;
        this.isValid = false;
        return false;
      }

      this.validationError = '';
      this.isValid = true;
      return true;
    }

    const isValid = currentCriteria.pattern.test(value);
    if (!isValid) {
      this.validationError = currentCriteria.errorMsg;
      this.isValid = false;
      return false;
    }


    if((currentCriteria.value === 'tcgid' ) && (value.length>10) ){
      this.validationError = 'TCGID should not be more then 10 digit';
      this.isValid = false;
      return false;
    }

    if((currentCriteria.value === 'pdbid') && (value.length>10) ){
      this.validationError = 'PDDBID should not be more then 10 digit';
      this.isValid = false;
      return false;
    }

    this.validationError = '';
    this.isValid = true;
    return true;
  }
  
  onSearchTextChange(value: string) {
    const data = this.dataSource.data;
    const searchResultsIndex = data.findIndex(item => item.name.split('(')[0].trim()==='SEARCH RESULTS');

    if (searchResultsIndex !== -1) {

      // Now set isExpanded to true
      data[searchResultsIndex].isExpanded = true; // Expand the item

      // Refresh data source with updated data
      this.dataSource.data = [...data];
      console.log(this.dataSource.data, "this.dataSource.data");
    }


    this.searchText = value;
    // For empty value, clear error and fetch data
    if (!value || value.trim() === '') {
      this.validationError = '';
      this.isValid = true;
      this.updateSearchWizard();
      return;
    }

    if (!this.validateInput(value)) {
      return;
    }

    console.log(this.searchText, "searchText---");


    // For non-empty value, validate and fetch if valid
    this.updateSearchWizard();
  }

  updateSearchWizard() {
    // Double-check validation before making API call
    if (this.searchText && this.searchText.trim() !== '' && !this.validateInput(this.searchText)) {
      return;
    }

    this.ngxLoader.start();
    this.getDrugData();
  }

  getDrugData() {
      // For non-empty values, validate before API call
      if (this.searchText && this.searchText.trim() !== '' && !this.validateInput(this.searchText)) {
        this.ngxLoader.stop();
        return;
      }
  
      this.erToolService.getDrugData(
        this.dataSourceId,
        this.searchText,
        this.permanentQuarantineValue,
        this.countryId,
        this.selectedSearchCriteria
      ).subscribe({
        next: (result) => {
          const initializedData = result.data?.map((item: any) => ({
            ...item,
            isExpanded: true ? item.name.split('(')[0].trim()==='SEARCH RESULTS' && this.searchText: false// Set to true for default expanded state
          }));
          this.ngxLoader.stop();
          this.dataSource = new MatTableDataSource(initializedData);
        },
        error: (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          const errorMessage = error.error?.message || error.message || 'An error occurred';
          this.toastService.openToast(
            errorMessage,
            constants.ToastPanelType.error,
            2
          );
        }
      });
  }

   getCountry() {
      this.ngxLoader.start();
      this.erToolService.getCountry().subscribe((result) => {
        this.ngxLoader.stop();
        this.listOfCountry = result.data;
      },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          this.toastService.openToast(
            error.message,
            constants.ToastPanelType.error,
            2
          );
        })
    }

  getDataSourceFilter() {
      this.ngxLoader.start();
      this.erToolService.getDataSourceFilter().subscribe((result) => {
        this.ngxLoader.stop();
        this.listOfDataSourceFilter = result.data;
      },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          this.toastService.openToast(
            error.message,
            constants.ToastPanelType.error,
            2
          );
        })
    }




}




